import { render } from "./ManagePeople.vue?vue&type=template&id=3c84353d&lang=pug"
import script from "./ManagePeople.vue?vue&type=script&lang=js"
export * from "./ManagePeople.vue?vue&type=script&lang=js"

import "./ManagePeople.vue?vue&type=style&index=0&id=3c84353d&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__